module.exports = __webpack_public_path__ + "img/polish.4faff19.jpg";